module.exports = __webpack_public_path__ + "static/media/OpenSansBold.1025a6e0.ttf";